import React, { PropTypes } from 'react';

import Star from 'AppComponents/Star';

import './styles.scss';


const Rating = ({ rating, type }) => {
  const stars = [];
  for (let i = 1; i <= 5; i += 1) {
    stars.push(
      <Star number={i} filled={i <= rating} key={i} styleName='star' />,
    );
  }
  return (
    <ol className={`rating ${type}`} styleName='rating'>
      { stars }
    </ol>
  );
};

Rating.propTypes = {
  rating: PropTypes.number.isRequired,
  type: PropTypes.string,
};

Rating.defaultProps = {
  rating: 0,
  type: 'stars',
};

export default Rating;



// WEBPACK FOOTER //
// ./app/scripts/views/App/components/Rating/index.jsx